import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit';

import { AgentsItem } from './components/AgentsItem';
import { BuilderItem } from './components/BuilderItem';
import * as styles from './styles.css';
import { IBuilder } from '../../types/newbuilding/builder';
import { ISeller } from '../../types/newbuilding/seller';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';

interface IBuildersAgentsProps {
  builders: IBuilder[];
  sellers: ISeller[];
}

export function BuildersAgents({ builders, sellers }: IBuildersAgentsProps) {
  const openBuilderPage = React.useCallback(
    (i: number) => {
      const builder = builders[i];

      if (builder) {
        window.open(builder.profileUrl, '_blank');
      }
    },
    [builders],
  );

  return (
    <Layout>
      <div className={styles['header']}>
        <ArticleHeading2 as="h2">Другие застройщики и представители</ArticleHeading2>
      </div>
      <VerticalSlider containerClass={styles['slider']} onItemClick={openBuilderPage}>
        {builders.map(builder => (
          <BuilderItem key={builder.id} {...builder} />
        ))}
        {sellers.map(seller => (
          <AgentsItem key={seller.realtyUserId} {...seller} />
        ))}
      </VerticalSlider>
    </Layout>
  );
}
